import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DepartmentsGlobalService } from '@core/services/store/departments-global.service';
import { Department } from '@features/settings/departments/models/departments.types';

export const departmentsResolver: ResolveFn<Department[]> = () => {
    const departmentsS = inject(DepartmentsGlobalService);

    if (!departmentsS.departments().length) {
        return departmentsS.getAllDepartments();
    } else {
        return departmentsS.departments();
    }
};
